import React, { useEffect, useState, useRef } from "react";
import "./GoogleForm.css";

export const GoogleForm = () => {
  const [height, setHeight] = useState(640);
  const [width, setWidth] = useState(750);
  const ref = useRef();
  useEffect(() => {
    setHeight(ref.current.clientHeight);
    setWidth(ref.current.clientWidth);
  });
  return (
    <div className="form__container" ref={ref}>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfRX4v95ANDVFM__OGjIB8uP9kXmTQalDckeZ-NdcIg4NIsrg/viewform?embedded=true"
        width={width}
        height={height}
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};
